import { ColumnConfig, ColumnDataType } from '@aurora';

export const companyColumnsConfig: ColumnConfig[] = [
    {
        type           : ColumnDataType.STRING,
        field          : 'tenant.name',
        searchableField: '$tenant.name$',
        sort           : 'tenant.name',
        translation    : 'Name',
        isUnaccent     : true,
    },
    {
        type           : ColumnDataType.STRING,
        field          : 'tenant.code',
        searchableField: '$tenant.code$',
        sort           : 'tenant.code',
        translation    : 'Code',
        isUnaccent     : true,
    },
    {
        type           : ColumnDataType.BOOLEAN,
        field          : 'tenant.isActive',
        searchableField: '$tenant.isActive$',
        sort           : 'tenant.isActive',
        translation    : 'Active',
        isUnaccent     : true,
    },
];
